module.exports = __webpack_public_path__ + "static/instaTest-7c44b7e2ffc53054c570d5147f738221.jpg";